<template>
  <base-overlay :show="loading">
    <template v-if="bookingDetails">
      <b-row>
        <b-col
          md="12"
          class="p-1 d-flex justify-content-between align-items-center"
        >
          <div>
            <div class="text-primary">
              Creation Date: {{ formatDate(bookingDetails.createdAt) }}
            </div>
            <div class="text-primary">
              Booking Time: {{ formatDate(bookingDetails.time) }}
            </div>
          </div>
          <div class="d-flex align-items-center gap-1">
            <b-badge
              variant="primary"
            >
              {{ snakeCaseToCamelCase(bookingDetails.service.class) }}
            </b-badge>
            <b-button
              v-if="bookingDetails.trip && bookingDetails.trip.id"
              variant="primary"
              size="sm"
              :href="`/trips/${bookingDetails.trip.id}`"
              target="_blank"
              class="ml-1"
            >
              <feather-icon
                icon="ExternalLinkIcon"
                size="16"
              />
              View Trip
            </b-button>
          </div>
        </b-col>
        <b-col
          v-if="bookingDetails.driver"
          md="4"
        >
          <Driver :driver="bookingDetails.driver" />
        </b-col>
        <b-col :md="bookingDetails.driver ? 4: 6">
          <User :user="bookingDetails.user" />
        </b-col>
        <b-col :md="bookingDetails.driver ? 4: 6">
          <ExtraDetails
            :number="bookingDetails.number"
            :state="bookingDetails.state"
          />
        </b-col>
        <b-col
          v-if="bookingDetails.state === 'CREATED' || bookingDetails.state === 'ACCEPTED'"
          md="12"
        >
          <AssignBookingDriver
            :booking="bookingDetails"
            @re-assigned="fetchDetails"
          />
        </b-col>
        <b-col md="12">
          <BookingTimeline :states="bookingDetails.states" />
        </b-col>
        <b-col md="12">
          <Location
            :pickup="bookingDetails.pickup"
            :dropoff="bookingDetails.dropoff"
          />
        </b-col>
        <b-col
          v-if="$can('write', 'schedules') && (bookingDetails.state == BOOKINGS_STATES.CREATED || bookingDetails.state == BOOKINGS_STATES.ACCEPTED)"
          md="12"
        >
          <BookingActions
            :booking-status="bookingDetails.state"
            @action-applied="fetchDetails"
          />
        </b-col>
      </b-row>
    </template>
  </base-overlay>
</template>

<script>
import { BRow, BCol, BBadge, BButton } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import Driver from '../components/booking-details/Driver.vue'
import User from '../components/booking-details/User.vue'
import ExtraDetails from '../components/booking-details/ExtraDetails.vue'
import Location from '../components/booking-details/Location.vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import formatDate from '@/utils/date-format'
import BookingActions from '../components/booking-details/BookingActions.vue'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import { BOOKINGS_STATES } from '../hooks/bookingUtils'
import BookingTimeline from '../components/booking-details/BookingTimeline.vue'
import AssignBookingDriver from '../components/booking-details/AssignBookingDriver.vue'

export default {
  components: {
    Driver,
    ExtraDetails,
    Location,
    BRow,
    BookingActions,
    AssignBookingDriver,
    BCol,
    BookingTimeline,
    BaseOverlay,
    User,
    BBadge,
    BButton,
  },
  setup(props, ctx) {
    const bookingDetails = ref()
    const bookingId = ctx.root.$route.params.id
    const loading = ref(false)
    const fetchDetails = async () => {
      loading.value = true
      const result = await axiosIns.get(`/booking/${bookingId}`)
      bookingDetails.value = result.data.data
      loading.value = false
    }
    fetchDetails()
    return {
      snakeCaseToCamelCase,
      fetchDetails,
      bookingDetails,
      loading,
      formatDate,
      BOOKINGS_STATES,
    }
  },
}
</script>
